import React, { useEffect, useState } from 'react';
import { Col, UncontrolledCollapse, NavLink, NavItem } from 'reactstrap';
import { MdClose, MdExpandMore, MdExpandLess } from "react-icons/md";
import Styles from './collapse-sub-menu.module.scss';
import { ISubMenuItem } from '@models/*';


interface CollapseSubMenuProps {
  subMenuList: string;
  Title: string;
  fetchSubMenuItems: (subMenuList: string) => Promise<ISubMenuItem[]>;
}

const CollapseSubMenuComponent: React.FC<CollapseSubMenuProps> = ({ subMenuList, Title, fetchSubMenuItems }) => {
  const [subMenuItems, setSubMenuItems] = useState<ISubMenuItem[]>([]);
  const [groupedSubMenuItems, setGroupedSubMenuItems] = useState<Record<string, ISubMenuItem[]>>({});
  const [openGroups, setOpenGroups] = useState<Record<string, boolean>>({}); // Estado para manejar los grupos abiertos/cerrados

  useEffect(() => {
    const fetchItems = async () => {
      if (subMenuList) {
        try {
          const items = await fetchSubMenuItems(subMenuList);
          setSubMenuItems(items);
        } catch (error) {
          console.error('Error fetching submenu items:', error);
          setSubMenuItems([]);
        }
      }
    };

    fetchItems();
  }, [subMenuList, fetchSubMenuItems]);

  useEffect(() => {
    const groupedItems = subMenuItems.reduce<Record<string, ISubMenuItem[]>>((acc, item) => {
      const { Title } = item;
      if (!acc[Title]) {
        acc[Title] = [];
      }
      acc[Title].push(item);
      return acc;
    }, {});
    setGroupedSubMenuItems(groupedItems);
  }, [subMenuItems]);

  const toggleGroup = (groupTitle: string) => {
    setOpenGroups((prev) => ({
      ...prev,
      [groupTitle]: !prev[groupTitle],
    }));
  };

  const redirectTo = (url: string) => {
    if (url.startsWith('http://') || url.startsWith('https://')) {
      window.location.href = url;
    } else {
      window.location.pathname = url;
    }
  };

  const renderSubMenuItems = (group: ISubMenuItem[]) => {
    return group.map((item) => (
      <NavItem key={item.ID} className={Styles.subMenuItem}>
        <NavLink onClick={() => redirectTo(item.BaseUrl + item.Url)}>
          {item.OCTAVIAValorTraduccion}
        </NavLink>
      </NavItem>
    ));
  };

  return (
    <UncontrolledCollapse toggler="#toggler-sub-menu-hidden">
      <Col xs={12} md={5} lg={4} className={Styles.SubMenuContainer}>
        <div className={Styles.header}>
          <span>{Title}</span>
          <label className={Styles.close} id="toggler-sub-menu-hidden">
            <MdClose />
          </label>
        </div>
        {Object.keys(groupedSubMenuItems).length > 0 ? (
          Object.keys(groupedSubMenuItems).map((groupTitle) => {
            const sanitizedTitle = groupTitle.replace(/\s+/g, '-');
            const group = groupedSubMenuItems[groupTitle];
            if (group.length === 1) {
              return renderSubMenuItems(group);
            } else {
              const isOpen = openGroups[sanitizedTitle] || false;
              return (
                <div key={sanitizedTitle} className={Styles.subMenuItem}>
                  <NavLink id={`toggler-${sanitizedTitle}`} onClick={() => toggleGroup(sanitizedTitle)}>
                    {groupTitle} {isOpen ? <MdExpandLess /> : <MdExpandMore />}
                  </NavLink>
                  <UncontrolledCollapse toggler={`#toggler-${sanitizedTitle}`}>
                    {renderSubMenuItems(group)}
                  </UncontrolledCollapse>
                </div>
              );
            }
          })
        ) : (
          <p>No sub-menu items available</p>
        )}
      </Col>
    </UncontrolledCollapse>
  );
};

export default CollapseSubMenuComponent;
